<template>
  <div>
    <div v-if="!gettingWeatherData">
      <div class="loader" />
    </div>
    <div v-if="gotAllData && gotWeatherData">
      <!-- sidebar weather module -->
      <div
        v-if="moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'True'"
        class="container max-w-screen-md lg:max-w-screen-sm mx-auto my-10 pt-4"
      >
        <h5
          v-if="
            $filters.hasPropertyValue(
              'ModuleTitle',
              moduleInfo.Module.ModuleProperties,
              moduleData
            )
          "
          class="overtitle-1 text-htz-steel text-left text-16 mb-5"
        >
          {{
            $filters.getPropertyValue( $t,
                                       "ModuleTitle",
                                       moduleInfo.Module.ModuleProperties,
                                       moduleData
            )
          }}
        </h5>
        <!-- current weather -->
        <div
          class="flex flex-row items-stretch justify-around p-xs text-htz-steel border-b border-htz-lightgrey py-4"
        >
          <Icon
            :icon-name="getWeatherIcon(currentTempInfo.Icon)"
            :icon-class="'icon ' + getWeatherIcon(currentTempInfo.Icon) + ' text-68'"
            :span-class="''"
          />
          <span class="flex flex-col items-stretch justify-evenly">
            <span>{{ $t("loc_weather_now") }}</span>
            <span
              class="text-32 text-htz-red leading-none"
            >{{ currentTempInfo.Temp }}°C</span>
          </span>

          <span class="flex flex-col items-stretch justify-evenly">
            <p>
              {{ $t("loc_weather_min_temp") }}
              <strong
                class="text-htz-red ml-2"
              >{{ weatherData.WeatherToday.MinTemp }}°C</strong>
            </p>
            <p>
              {{ $t("loc_weather_max_temp") }}
              <strong
                class="text-htz-blue ml-2"
              >{{ weatherData.WeatherToday.MaxTemp }}°C</strong>
            </p>
          </span>
          <span
            v-if="getHighestSeaTemp(seaTempData.Termin)"
            class="flex flex-col items-stretch justify-evenly"
          >
            <p>{{ $t("loc_weather_sea_temp") }}</p>
            <p>
              <strong class="text-htz-blue">
                {{ getHighestSeaTemp(seaTempData.Termin) }}°C
              </strong>
            </p>
          </span>
        </div>
        <!-- three day weather -->
        <div class="flex justify-around border-b border-htz-lightgrey py-4">
          <div
            v-for="(day) in weatherData.DayWeatherList"
            :key="day.DayName"
            class="flex flex-col items-center justify-center text-htz-steel text-16 space-y-1"
          >
            <Icon
              :icon-name="getWeatherIcon(day.Icon, true)"
              :icon-class="'icon ' + getWeatherIcon(day.Icon, true) + ' text-68'"
              :span-class="''"
            />

            <span>{{
              $t(
                $filters.stringFormat(
                  "loc_weather_day_{0}",
                  $filters.lowercase(day.DayName)
                )
              )
            }}</span>
            <span class="text-htz-red text-18">{{ day.AvgTemp }}°C</span>
          </div>
        </div>
      </div>

      <!-- big weather module -->
      <div
        v-if="
          moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' ||
            moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === ''
        "
        class="container max-w-screen-xl mx-auto my-8"
      >
        <h4
          v-if="
            $filters.hasPropertyValue(
              'ModuleTitle',
              moduleInfo.Module.ModuleProperties,
              moduleData
            )
          "
          class="headline-4 text-htz-steel mb-5"
        >
          {{
            $filters.getPropertyValue( $t,
                                       'ModuleTitle',
                                       moduleInfo.Module.ModuleProperties,
                                       moduleData
            )
          }}
        </h4>
        <div class="flex justify-between md:px-8">
          <div
            v-for="(day, index) in weatherData.DayWeatherList"
            :key="day.DayName"
            class="flex flex-col items-center justify-center text-htz-steel text-15 md:text-18 space-y-6 lg:space-y-8"
          >
            <span
              v-if="index === 0"
              class="text-htz-darkteal"
            >{{
              $t("loc_weather_today")
            }}</span>
            <span v-else-if="display === 'mobile'">{{
              $t(
                $filters.stringFormat(
                  "loc_weather_day_{0}",
                  $filters.lowercase(day.DayName)
                )
              ).substring(0, 3)
            }}</span>
            <span v-else>{{
              $t(
                $filters.stringFormat(
                  "loc_weather_day_{0}",
                  $filters.lowercase(day.DayName)
                )
              )
            }}</span>

            <Icon
              :icon-name="getWeatherIcon(day.Icon, true)"
              :icon-class="'icon ' + getWeatherIcon(day.Icon, true) + ' text-40 sm:text-48 md:text-68 lg:text-80'"
              :span-class="''"
            />
            <span
              :class="{ 'text-htz-darkteal': index === 0 }"
            >{{ day.AvgTemp }}°C</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosInstance from "@/services/http-common";
import {selfDataRequestMixin} from "@/mixins";
import Icon from "@/components/includes/Icon";

export default {
  name: "Weather",
  components: {
    Icon,
  },
  mixins: [selfDataRequestMixin],
  props: {
    moduleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      weatherData: {},
      gettingWeatherData: false,
      currentTempInfo: {},
      display: "desktop",
      // weatherContainerTypeId: 0,
      // cityTypeId: 0,
      city: {},
      seaTempData: {},
      defaultCity: {},
    };
  },
  computed: {
    gotWeatherData: function () {
      if (this.weatherData && this.weatherData.WeatherToday) {
        this.getCurrentTemp(this.weatherData.WeatherToday.TodayList);
        return true;
      }
      return false;
    },
    gotAllData: function () {
      if (
        this.moduleInfo
        && this.$store.state.Params.length > 0
      ) {
        this.getCityData();
        if(this.gotCityData){
          this.getWeatherData();
        }
      }
      return this.gettingWeatherData;
    },
    gotCityData: function() {
      if(this.city){
        return Object.keys(this.city).length > 0;
      } else if (this.defaultCity){
        return Object.keys(this.defaultCity).length > 0;
      } else if (this.positionOnMap){
        return true;
      }
      else {
        return false;
      }
    },
    weatherContainerTypeId() {
      return +this.$store.state.Params.find(o => o.Key === 'WeatherContainerTypeId')?.Value || 0
    },
    cityTypeId() {
      return +this.$store.state.Params.find(o => o.Key === 'CityTypeId')?.Value || 0
    },
    defaultCityID () {
      return  this.$store.state.Params.find(o => o.Key === 'DefaultCityID')?.Value ||  "";
    },
    defaultSeaCityName () {
      return  this.$store.state.Params.find(o => o.Key === 'DefaultSeaCityName')?.Value ||  "";
    },
    seaCityName() {
      return  this.$filters.getPropertyValue(  this.$t,
                "ModuleSeaTemp",
                this.moduleInfo.Module.ModuleProperties,
                this.moduleData
              ) ||  "";
    },
    positionOnMap () {
      return  this.firstModuleDataItem.PositionOnMap ||  "";
    },
    // gotSeaTempData(){
    //   if (this.gotWeatherData && (this.$filters.hasPropertyValue(
    //             "ModuleSeaTemp",
    //             this.moduleInfo.Module.ModuleProperties,
    //             this.moduleData
    //           ) || this.defaultSeaCityName != '')) {
    //     this.getSeaTempData();
    //     return true;
    //   }
    //   return false;
    // }
    /*
    *
    * */
  },
  mounted() {
    this.windowWidth();
    this.getAndFillParameters();
  },
  methods: {
    getCityData() {
      if (
        !this.gotCityData &&
        !this.gettingWeatherData
      ){
        axiosInstance
            .post("/api/entities", {
              EntityTypeID: this.cityTypeId,
            })
            .then((response) => {
              const res = response.data;
              const moduleCityCode = this.moduleInfo.Module.ModuleProperties.ModuleCityCode || '';
              this.city = res.find(obj => obj.EntityID == moduleCityCode);
              this.defaultCity = res.find(obj => obj.EntityID == this.defaultCityID);
              if(!this.city && !this.defaultCity && !this.positionOnMap){
                this.gettingWeatherData = true;
              }
            })
            .catch((e) => {
              this.error = e;
              this.gettingWeatherData = true;
            });
      }
    },
    getWeatherData() {
      if (
        this.gotCityData &&
        !this.gettingWeatherData
      ) {
        axiosInstance
          .post("/api/entities/services", {
            ServiceType: "Weather",
            DefaultCityCode: this.defaultCity?.Properties?.find((obj) => obj.Name == 'CityCode').Value,
            CityCode: this.city?.Properties?.find((obj) => obj.Name == 'CityCode').Value,
            ShowWeatherAsSidebar: this.moduleInfo.Module.ModuleProperties
              .ModuleShowAsSidebar,
            LanguageID: this.$store.state.PageData.LanguageId,
            WeatherTypeId: this.weatherContainerTypeId,
            CityTypeId: this.cityTypeId,
            PositionOnMap: this.positionOnMap,
            SeaTempStation: this.seaCityName,
          })
          .then((response) => {
            this.weatherData = response.data;
            this.seaTempData = this.weatherData.SeaTempStation ? this.weatherData.SeaTempStation : {};
            this.gettingWeatherData = true;
          })
          .catch((e) => {
            this.error = e;
            this.gettingWeatherData = true;
          });
      } else {
        this.gettingWeatherData = true;
      }
    },
    // getSeaTempData() {
    //   if (
    //     this.gotWeatherData && this.weatherData.SeaTempList.length
    //   ) {

    //     const moduleSeaTempName = this.$filters.hasPropertyValue(
    //             "ModuleSeaTemp",
    //             this.moduleInfo.Module.ModuleProperties,
    //             this.moduleData
    //           ) ? this.$filters.getPropertyValue(  this.$t,
    //             "ModuleSeaTemp",
    //             this.moduleInfo.Module.ModuleProperties,
    //             this.moduleData
    //           ) : this.defaultSeaCityName;
    //           console.log({moduleSeaTempName})
    //         if(moduleSeaTempName != ''){
    //           const seaTempListArr = this.weatherData.SeaTempList.filter((obj) => obj.Naziv == moduleSeaTempName);
    //           this.seaTempData = seaTempListArr.length > 0 ? seaTempListArr[0] : {};
    //         }
    //   }
    // },
    getCurrentTemp(arr) {
      if (arr) {
        let currentDate = new Date();
        let currentHour = currentDate.getHours();
        this.currentTempInfo = arr?.reduce((obj1, obj2) => {
            return Math.abs(obj2.Hour - currentHour) < Math.abs(obj1.Hour - currentHour) ? obj2 : obj1;
        });
      }
    },
    getHighestSeaTemp(seaTempArr){
      if(seaTempArr){
        return seaTempArr.sort(function(a, b){return b-a})[0];
      }
    },
    windowWidth: function () {
      if (window.innerWidth > 768) {
        this.display = "desktop";
      } else {
        this.display = "mobile";
      }
    },
    getWeatherIcon(icon, isDay = false) {
      let iconName = '';
      let iconStr = icon;
      if (/[a-zA-Z]$/.test(icon)) {
        iconStr = isDay ? icon?.substring(0, icon?.length - 1) : icon;
      }
      switch(iconStr){
        case '7':
        case '8':
        case '9':
        case '10':
        case '11':
        case '41':
        case '42':
        case '7n':
        case '8n':
        case '9n':
        case '10n':
        case '11n':
        case '41n':
        case '42n':
          iconName = 'icon-fog-ico';
          break;
        case '14':
        case '28':
        case '14n':
        case '28n':
          iconName = 'icon-heavy-rain-ico';
          break;
        case '26':
        case '27':
        case '33':
        case '12n':
        case '13n':
        case '16n':
        case '17n':
        case '18n':
        case '26n':
        case '27n':
        case '33n':
          iconName = 'icon-light-rain-ico';
          break;
        case '19':
        case '20':
        case '21':
        case '22':
        case '23':
        case '24':
        case '25':
        case '34':
        case '35':
        case '36':
        case '37':
        case '38':
        case '40':
        case '19n':
        case '20n':
        case '21n':
        case '22n':
        case '23n':
        case '24n':
        case '25n':
        case '40n':
        case '34n':
        case '35n':
        case '36n':
        case '37n':
        case '38n':
          iconName = 'icon-snow-ico';
          break;
        case '3':
        case '4':
        case '5':
        case '6':
          iconName = 'icon-weather-cloudy-ico';
          break;
        case '3n':
        case '4n':
        case '5n':
        case '6n':
        case '39n':
          iconName = 'icon-cloudy-night-ico';
          break;
        case '12':
        case '13':
        case '16':
        case '17':
        case '18':
        case '39':
          iconName = 'icon-sun-cloud-rain-ico';
          break;
        case '1':
        case '2':
          iconName = 'icon-weather-sunny-ico';
          break;
        case '15':
        case '29':
        case '30':
        case '31':
        case '32':
        case '15n':
        case '29n':
        case '30n':
        case '31n':
        case '32n':
          iconName = 'icon-thunder-rain-ico';
          break;
        case '1n':
        case '2n':
          iconName = 'icon-starry-night-ico';
          break;
        default:
          iconName = 'icon-weather-sunny-ico';
          break;
      }
      return iconName;
    },
    getAndFillParameters: function () {
     /* this.$parameters
        .getParameter("WeatherContainerTypeId", "")
        .then((response) => {
          this.weatherContainerTypeId = response;
        });
      this.$parameters.getParameter("CityTypeId", "").then((response) => {
        this.cityTypeId = response;
      });*/
    },
  },
};
</script>

<style></style>
